export default __webpack_public_path__ + "static/media/2061.4a17c6b7.png";